import { __read } from "tslib";
import React, { useState } from 'react';
export var AmountFilter = function (props) {
    var apply = props.apply;
    var _a = __read(useState(0), 2), value = _a[0], setValue = _a[1];
    var changeValue = function (event) {
        var newValue = event.target.value;
        setValue(newValue);
    };
    var onClickApply = function () {
        apply(value);
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "minimum-filter" },
            React.createElement("input", { type: 'number', name: 'minimumAvailable', title: 'minimumAvailable', value: value, onChange: changeValue }),
            React.createElement("button", { onClick: onClickApply }, "Apply")));
};
//# sourceMappingURL=AmountFilter.js.map